import React, { useState } from 'react';
import '../dropdown/Reviews.css';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaArrowRight } from 'react-icons/fa';
import { MdSpeed } from 'react-icons/md'; // Adding a "test drive" icon
import swift2 from '../assets/swift2.png';
import altroz from '../assets/altroz.png';
import xuv3x0 from '../assets/3xo.png';
import creta from '../assets/creta.png';
import Pagination from './Pagination';
import SidebarExpertReviews from './SidebarExpertReviews';
import SidebarElectricVehicles from './SidebarElectricVehicles';

const Reviews = () => {
  const reviews = [
    {
      id: 1,
      title: "2026 Maruti Swift Review: Is the Z-Series engine a game-changer?",
      price: "₹6.49 - ₹9.64 Lakh",
      description: "Our comprehensive test drive reveals the new 1.2L Z-Series engine in the 2026 Swift truly improves fuel efficiency and driving dynamics. We assess its safety suite and refined interior.",
      image: swift2,
      link: "https://www.marutisuzuki.com/swift",
      date: "June 17, 2026",
      rating: "4.5/5"
    },
    {
      id: 2,
      title: "Tata Altroz Racer First Drive: More Than Just a Turbocharged Hatch?",
      price: "₹9.50 - ₹11.00 Lakh",
      description: "The Altroz Racer promises exhilarating performance with its 120 PS turbo-petrol engine. We put its sportier suspension to the ultimate test on technical roads.",
      image: altroz,
      link: "https://cars.tatamotors.com/altroz/ice.html", 
      date: "June 14, 2026",
      rating: "4.2/5"
    },
    {
      id: 3,
      title: "Mahindra XUV 3XO Review: Redefining Compact SUV Benchmarks",
      price: "₹7.99 - ₹15.56 Lakh",
      description: "With a panoramic sunroof and Level 2 ADAS, the XUV 3XO is packed with segment-firsts. We dive deep into its cabin practicality and real-world tech performance.",
      image: xuv3x0,
      link: "https://auto.mahindra.com/suv/xuv3xo/X3XO.html", 
      date: "May 28, 2026",
      rating: "4.8/5"
    },
    {
      id: 4,
      title: "Hyundai Creta Facelift: Still the Undisputed King of the Segment?",
      price: "₹11.00 - ₹20.15 Lakh",
      description: "The refreshed Creta dominates sales. We evaluate its bold new styling, the 1.5L turbo-petrol punch, and how the ADAS performs in chaotic city traffic.",
      image: creta,
      link: "https://www.hyundai.com/in/en/find-a-car/creta/highlights", 
      date: "April 05, 2026",
      rating: "4.7/5"
    }
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reviews.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(reviews.length / itemsPerPage);

  return (
    <div className="reviews-view-container">
      <header className="reviews-hero-header">
        <div className="hero-content-wrapper">
          <span className="hero-tag">Expert Road Tests</span>
          <h1>Detailed Reviews</h1>
          <p>We push every vehicle to its limit to help you make the right choice.</p>
          <div className="header-divider"></div>
        </div>
      </header>

      <div className="reviews-main-layout">
        <main className="reviews-feed">
          {currentItems.map((car) => (
            <article className="review-horizontal-card" key={car.id}>
              <div className="review-image-section">
                <img src={car.image} alt={car.title} />
                <div className="review-rating-badge"><MdSpeed /> {car.rating}</div>
              </div>

              <div className="review-details-section">
                <div className="review-meta-row">
                  <span className="review-price">{car.price}</span>
                </div>
                
                <h3 className="review-title">{car.title}</h3>
                <p className="review-description">{car.description}</p>
                
                <div className="review-footer-action">
                  <a href={car.link} className="premium-review-btn">
                    Read Report <FaArrowRight />
                  </a>
                  <div className="social-share-pills">
                    <FaFacebookF />
                    <FaTwitter />
                    <FaLinkedinIn />
                  </div>
                </div>
              </div>
            </article>
          ))}

          <div className="pagination-bottom">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </main>

        <aside className="reviews-sidebar">
          <SidebarExpertReviews />
          <SidebarElectricVehicles />
        </aside>
      </div>
    </div>
  );
};

export default Reviews;